import { useState, useEffect, useRef } from "react";

import { API_URL } from "../helpers";

import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Q1Fields from "./Q1Fields";
import Q2Fields from "./Q2Fields";
import Q3Fields from "./Q3Fields";
import Q4Fields from "./Q4Fields";
import Q5Fields from "./Q5Fields";
import Q6Fields from "./Q6Fields";
import Q7Fields from "./Q7Fields";

export default function Questions({
	details,
	setDetails,
	question,
	setQuestion,
	q,
}) {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef();

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	/*
  const handleCheckboxes = (name, checked, val) => {
    let newValue = "";
    if (checked) {
      newValue = val;
    }
    setNames((names) => ({ ...names, [name]: newValue }));
  };
  */

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/survey`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.append("question", question);
		formData.append("fname", details.fname);
		formData.append("lname", details.lname);
		formData.append("company", details.company);
		formData.append("email", details.email);
		formData.append("q", q);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				if (json.text) {
					// finished
					setDetails({ text: json.text });
					setQuestion(parseInt(json.nextQuestion, 10));
				} else {
					setErrors([]);
					setMsg({});
					setQuestion(parseInt(json.nextQuestion, 10));
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			<div className="blocktext step">
				<div>
					<p>
						Thank you for supporting your attendees through the VTO/BFC Event
						dashboard. As a primary point of contact for our business partners,
						your feedback is critical to improving the experience. This survey
						should take approximately 5-7 minutes to complete. All responses
						will be reviewed to enhance future events.
					</p>
				</div>
			</div>

			<table className="approved assigned">
				<thead>
					<tr>
						<th width="33%">Name</th>
						<th>Company</th>
						<th width="33%">Email</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{`${details.fname} ${details.lname}`}</td>
						<td>{`${details.company}`}</td>
						<td>{`${details.email}`}</td>
					</tr>
				</tbody>
			</table>

			<h3
				style={{
					marginTop: "25px",
					marginBottom: "0",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<span>Survey Questions</span>
				<span>{`${question} of 7`}</span>
			</h3>

			<p style={{ marginBottom: "20px" }}></p>

			<form
				ref={formElement}
				method="post"
				action="/"
				onSubmit={(e) => handleSubmit(e)}
				className="well"
			>
				{question === 1 ? (
					<Q1Fields handleUpdate={handleUpdate} errors={errors} />
				) : question === 2 ? (
					<Q2Fields
						handleUpdate={handleUpdate}
						errors={errors}
						q2_3={names.q2_3 ? names.q2_3 : ""}
					/>
				) : question === 3 ? (
					<Q3Fields
						handleUpdate={handleUpdate}
						errors={errors}
						q3_3={names.q3_3 ? names.q3_3 : ""}
					/>
				) : question === 4 ? (
					<Q4Fields handleUpdate={handleUpdate} errors={errors} />
				) : question === 5 ? (
					<Q5Fields handleUpdate={handleUpdate} errors={errors} />
				) : question === 6 ? (
					<Q6Fields
						handleUpdate={handleUpdate}
						errors={errors}
						q6_3={names.q6_3 ? names.q6_3 : ""}
					/>
				) : question === 7 ? (
					<Q7Fields handleUpdate={handleUpdate} errors={errors} />
				) : (
					<div />
				)}

				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit
							submit={
								question === 7 ? "Submit & Complete" : "Submit & Continue"
							}
						/>
					</div>
				</div>
			</form>
		</>
	);
}
